import React, { Component } from "react"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"

class CustomFieldLabel extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            definitionId: this.props.definitionId || "",
            className: this.props.className || "",
            name: ""
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            definitionId: nextProps.definitionId || ""
        })
        this.loadDefinition(nextProps.definitionId)
    }

    loadDefinition(definitionId) {
        AppContext.getApiClient()
            .get("/custom-field-definitions/" + definitionId)
            .then(d => {
                this.setState({
                    name: d.attributes.name
                })
            })
    }

    componentDidMount() {
        this.loadDefinition(this.state.definitionId)
    }

    render() {
        return <span className={this.state.className}>{this.state.name}</span>
    }
}

export default CustomFieldLabel



// WEBPACK FOOTER //
// ./src/common/custom-field/label.component.jsx